import * as Actions from '../../actions';

const initialState = { data: null };

const listSubUsersReducer = function (state = initialState, action) {
    switch (action.type) {
        case Actions.GET_SUB_USERS_LIST_DETAILS:
            return { ...state, data: { ...action.payload } };
        default:
            return state;
    }
};

export default listSubUsersReducer;
